export const SEND_INVITE_REQUEST = 'SEND_INVITE_REQUEST';
export const SEND_INVITE_SUCCESS = 'SEND_INVITE_SUCCESS';
export const SEND_INVITE_FAILED = 'SEND_INVITE_FAILED';

export const GET_DATA_FOR_INVITE_FORM_REQUEST = 'GET_DATA_FOR_INVITE_FORM_REQUEST';
export const GET_DATA_FOR_INVITE_FORM_SUCCESS = 'GET_DATA_FOR_INVITE_FORM_SUCCESS';
export const GET_DATA_FOR_INVITE_FORM_FAILED = 'GET_DATA_FOR_INVITE_FORM_FAILED';
